/**
 * Web App Configuration
 * Centralized configuration for web app URLs
 */

import { DEFAULT_AUTH_NEXT } from '../utils/authIntent'

const ALLOWED_WEB_APP_PREFIXES = [
  'https://app.zypheron.net',
  'https://eclectic-khapse-814464.netlify.app',
]

// Get the web app URL from environment variable, with the existing safe
// same-site fallback if deployment configuration is missing or invalid.
const getWebAppUrl = (): string => {
  const envUrl = import.meta.env.VITE_WEB_APP_URL

  if (envUrl) {
    const normalized = String(envUrl).replace(/\/+$/, '')
    if (ALLOWED_WEB_APP_PREFIXES.some((prefix) => normalized.startsWith(prefix))) {
      return normalized
    }

    // eslint-disable-next-line no-console
    console.error(`VITE_WEB_APP_URL "${envUrl}" is not an allowed Zypheron app URL; falling back to /download.`)
  }

  return '/download'
}

export const WEB_APP_URL = getWebAppUrl()

const buildWebAppPath = (path: string): string => {
  if (!WEB_APP_URL.startsWith('http')) return WEB_APP_URL
  return `${WEB_APP_URL}${path}`
}

// Helper functions for common web app routes
export const webAppRoutes = {
  home: WEB_APP_URL,
  login: buildWebAppPath('/login'),
  loginForEngagements: buildWebAppPath(`/login?next=${DEFAULT_AUTH_NEXT}`),
  dashboard: buildWebAppPath('/dashboard'),
  engagements: buildWebAppPath(DEFAULT_AUTH_NEXT),
  signup: buildWebAppPath('/signup'),
  signupForEngagements: buildWebAppPath(`/signup?next=${DEFAULT_AUTH_NEXT}`),
}

// Helper function to navigate to web app
export const navigateToWebApp = (path: string = '/') => {
  window.location.href = buildWebAppPath(path)
}
